// internals
import type { RecentDeal } from '../types/RecentDeals';

/**
 * A Recent Deals / Deal List row is a quote when it has no customer attached (`customerId` is empty).
 *
 * Quick Quotes are created without a shopper, so DealXG returns them with no buyer (`commonConsumerId` empty)
 * and the CRW rows path maps them to the 'Unknown Customer' placeholder with an empty `consumerId`. Both map
 * to the same signal here, which is also what getRecentDealDisplayName keys the `Q-{dealerId}-...` naming on.
 */
export const isQuoteDeal = (deal: Pick<RecentDeal, 'customerId'>): boolean => !deal.customerId;
